import { render, staticRenderFns } from "./QRCodeInstallation.vue?vue&type=template&id=1585be18&scoped=true"
import script from "./QRCodeInstallation.vue?vue&type=script&lang=js"
export * from "./QRCodeInstallation.vue?vue&type=script&lang=js"
import style0 from "./QRCodeInstallation.vue?vue&type=style&index=0&id=1585be18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1585be18",
  null
  
)

export default component.exports